import React from 'react';
import { List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { Home, AttachMoney, AddPhotoAlternate } from '@mui/icons-material';

const FeatureList = () => {
  const features = [
    {
      icon: <Home sx={{ color: 'primary.main' }} />,
      primary: 'トップページで作品が紹介されます。',
      secondary: null
    },
    {
      icon: <AttachMoney sx={{ color: 'success.main' }} />,
      primary: '作品の投稿の評価に応じて活動支援金をお支払いします。',
      secondary: '収益化には別途、課金プラン加入(スタンダードまたはプレミアム、プレミアムプラス)が必要です。'
    },
    {
      icon: <AddPhotoAlternate sx={{ color: 'secondary.main' }} />,
      primary: '投稿枚数無制限',
      secondary: null
    }
  ];

  return (
    <List sx={{ width: '100%', maxWidth: 600 }}>
      {features.map((feature, index) => (
        <ListItem 
          key={index} 
          alignItems="flex-start"
          sx={{ mb: 0 }}
        >
          <ListItemIcon sx={{ minWidth: 48, mt: 0 }}>
            {feature.icon}
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                {feature.primary}
              </Typography>
            }
            secondary={
              feature.secondary && (
                <Typography
                  variant="body2"
                  sx={{ color: 'text.secondary', mt: 0.5 }}
                >
                  {feature.secondary}
                </Typography>
              )
            }
          />
        </ListItem>
      ))}
    </List>
  );
};

export default FeatureList;